import * as React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 26"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="r6vrj30keb">
        <stop stopColor="#F88E51" offset="0%" />
        <stop stopColor="#FF4519" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="5l9ed4scba">
        <stop stopColor="#FFAD7C" offset="0%" />
        <stop stopColor="#FF795B" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="15.078%"
        y1="25.501%"
        x2="91.089%"
        y2="76.388%"
        id="zb5nic6p3c"
      >
        <stop stopColor="#FFE9E1" offset="0%" />
        <stop stopColor="#FFE9E1" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M11.82.5c2.85 0 5.43 1.155 7.297 3.023a10.287 10.287 0 0 1 3.022 7.297c0 2.468-1.54 5.495-3.44 8.16-2.494 3.5-5.654 6.52-6.88 6.52-1.225 0-4.385-3.02-6.879-6.52-1.9-2.665-3.44-5.692-3.44-8.16 0-2.85 1.155-5.43 3.023-7.297A10.287 10.287 0 0 1 11.82.5Z"
        stroke="url(#5l9ed4scba)"
        fill="url(#r6vrj30keb)"
      />
      <path
        d="M1.192 5.5H.73C.327 5.5 0 5.228 0 4.891v-.783C0 3.772.327 3.5.73 3.5h.457c.209-1.158.867-2.085 2.002-2.765.837-.5 1.783-.73 2.809-.734 2.025-.01 4.378 1.232 4.75 3.496h.521c.404 0 .731.273.731.609v.778c0 .337-.327.61-.73.61h-.457l-.552 3.968c-.043.307-.355.539-.726.539H2.441c-.373 0-.686-.233-.727-.543L1.192 5.5Zm8.141-1.796C9.141 2.375 7.795 1.088 5.965 1.11c-1.904.024-3.128 1.376-3.298 2.593h6.666ZM4.444 8.519V5.926H3.111v2.593h1.333ZM8.89 5.926H7.556v2.593h1.333V5.926Z"
        transform="translate(6 6)"
        fill="url(#zb5nic6p3c)"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
